import unauthenticatedFetch from 'services/rest/unauthenticatedFetch';
import { Headers } from 'shared/constants/headers';
import { z } from 'zod';

export interface AcceptCSTChallengeData {
  challengeId?: string;
  otpCode?: string;
  acceptOptions: {
    tokenOption: {
      tokenReference: string;
    };
  };
}

const acceptCSTChallengeResponseSchema = z.object({
  challengeVerified: z.boolean().optional(),
  errorMessage: z.string().optional(),
  acceptChallengeId: z.string().optional(),
  challengeContext: z.string().optional(),
  title: z.string().optional(),
  errorCode: z
    .union([z.string(), z.number()])
    .transform((value) => Number(value))
    .optional(),
  message: z.string().optional(),
  version: z.string().optional(),
});

export type AcceptCSTChallengeResponse = z.infer<
  typeof acceptCSTChallengeResponseSchema
>;

export default async function fetchAcceptCSTChallenge(
  lambdaUrl: string,
  data: AcceptCSTChallengeData,
  headers: Headers,
): Promise<AcceptCSTChallengeResponse> {
  const response = await unauthenticatedFetch(`${lambdaUrl}/accept-challenge`, {
    method: 'POST',
    cache: 'no-cache',
    body: JSON.stringify(data),
    headers,
  });

  const result: unknown = await response.json();
  return acceptCSTChallengeResponseSchema.parse(result);
}
